import { ICON_TYPES, WELLBEING_ICONS } from './types';

export function getWellbeingIcon(ev: any) {
  if (ev.survey_type === 'signature_signs') {
    //TODO check for significant life event
    return ICON_TYPES.GREEN_Z;
  }
  if (ev.survey_type === 'HoNOS' || ev.survey_type === 'K10') {
    //TODO actually score these.. for now random..
    const randomIndex = Math.floor(Math.random() * WELLBEING_ICONS.length);
    return WELLBEING_ICONS[randomIndex];
  }
  return undefined;
}
